import { api } from '../api'
import { ServiceWithRFQID } from '../Service'
import { Model, ModelNew, ModelPO, ModelInfoPOShort, ModelFrance, ModelUSA, ModelSharedForm } from './models'
import { setToModel } from '@/utils/objects'
import { ServiceRFQ1s } from '@/services/RFQ1s'
import { ServiceRFQ2s } from '@/services/RFQ2s'
import { ServiceSalesOrders } from '@/services/SalesOrders'
import { getCurrentEmployee } from '@/utils/shared'
import { ServiceRepairExchangeOrderFollowUp } from '@/services/RepairExchangeOrderFollowUp'

const ENDPOINTS = {
  GET: 'RFQs/Get',
  GET_DYNAMIC: 'RFQs/GetAllDynamic',
  POST: 'RFQs/Create',
  PATCH: 'RFQs/Patch',
  PUT: 'RFQs/Put',
  DELETE: 'RFQs/Delete',
  CLOSE_PO: 'RFQs/ClosePO'
}

class ModuleServiceRFQs extends ServiceWithRFQID {
  async createRFQ (data) {
    let _data = { ...data, entryDate: new Date(), pOisOpen: true }
    return this.post(_data)
  }
  async createRFQAndPO ({ dataRFQ, sharedData, listRFQ2s = [] }) {
    const { data: resultRFQ } = await this.createRFQ(setToModel(ModelNew(), dataRFQ))

    const { rfqid } = resultRFQ
    await this._createPoWoRFQ1AndUpdateRFQ2({ rfqid }, listRFQ2s)
    const { data: resultSalesOrder } = await this._createPoWoSalesOrder(sharedData, listRFQ2s[0])
    await this._createPoWoRepairExchangeOrderFollowUps(sharedData, listRFQ2s)

    return {
      data: {
        rfq: { ...resultRFQ },
        salesOrder: { ...resultSalesOrder }
      }
    }
  }
  async createPO (data) {
    let _data = { ...data, pOisOpen: true, rfqid: undefined }
    return this.patch(_data)
  }
  async closePO ({ id }) {
    return api.put(`${ENDPOINTS.CLOSE_PO}/${id}`)
  }
  async createPoWo ({ dataRFQ, sharedData, listRFQ2s = [], updatePoDate = true }) {
    try {
      await this._updatePoWoRFQ({ id: dataRFQ.id, ...sharedData }, updatePoDate)
      await this._createPoWoRFQ1AndUpdateRFQ2({ rfqid: dataRFQ.rfqid }, listRFQ2s)
      const { data: resultSalesOrder } = await this._createPoWoSalesOrder(sharedData, listRFQ2s[0])
      await this._createPoWoRepairExchangeOrderFollowUps(sharedData, listRFQ2s)
      return {
        data: {
          rfq: { ...dataRFQ, po: sharedData.po },
          salesOrder: { ...resultSalesOrder }
        }
      }
    } catch (e) {
      return Promise.reject(e)
    }
  }
  async _updatePoWoRFQ (data, updatePoDate = true) {
    const model = {
      id: null,
      rfqid: '',
      rfqTypeID: null,
      customerCompanyID: null,
      customerContactID: null,
      customerCompanyDetailID: null,
      po: null,
      poDate: updatePoDate ? new Date() : undefined
    }
    return this.createPO(setToModel(model, data))
  }
  async _createPoWoRFQ1AndUpdateRFQ2 ({ rfqid }, listRFQ2 = []) {
    return Promise.all(listRFQ2.map((itemRFQ2) => {
      const { id, qty, partID } = itemRFQ2
      return ServiceRFQ1s
        .post({ rfqid, qty, partID })
        .then(() => {
          return ServiceRFQ2s
            .patch({ id, rfqid, chosen: true })
        })
    }))
  }
  async _createPoWoSalesOrder (sharedData, { supplierCompanyID, supplierContactID }) {
    let data = {
      rfqid: sharedData.rfqid,
      shipToCompanyID: sharedData.shipToCompanyID,
      shipToCompanyDetailID: sharedData.shipToCompanyDetailID,
      shipToCompanyContactID: sharedData.shipToCompanyContactID,
      supplierCompanyID: supplierCompanyID,
      supplierCompanyContactID: supplierContactID,
      vatID: sharedData.vatID,
      shipViaForwarderID: sharedData.shipViaForwarderID,
      priorityID: sharedData.priorityID,
      po: sharedData.po,
      baxpo: sharedData.baxPO
    }
    return ServiceSalesOrders
      .post(data)
  }
  async _createPoWoRepairExchangeOrderFollowUps ({ rfqid, baxPO }, listRFQ2) {
    const employeeID = getCurrentEmployee().id
    return Promise.all(listRFQ2.map((itemRFQ2) => {
      const { id, partID, partSN } = itemRFQ2
      const data = {
        rfQ2ID: id,
        partID: partID,
        partSN: partSN,
        rfqid: rfqid,
        baxpo: baxPO,
        orderPhaseID: 29,
        phaseDate: new Date(),
        phasePersonInChargeEmployeeID: employeeID
      }
      return ServiceRepairExchangeOrderFollowUp
        .post(data)
        .then(({ data: dataExchange }) => {
          const dataLog = {
            repairExchangeOrderFollowUpID: dataExchange.id,
            employeeID,
            entryDate: new Date(),
            description: 'new PO',
            isEmployeeEntry: false,
            isRead: false
          }
          return ServiceRepairExchangeOrderFollowUp
            .createLog(dataLog)
        })
    }))
  }
}

export const ServiceRFQs = new ModuleServiceRFQs({
  apiGet: ENDPOINTS.GET,
  apiGetDynamic: ENDPOINTS.GET_DYNAMIC,
  apiPost: ENDPOINTS.POST,
  apiPatch: ENDPOINTS.PATCH,
  apiPut: ENDPOINTS.PUT,
  apiDelete: ENDPOINTS.DELETE
})

export {
  Model as ModelRFQs,
  ModelPO,
  ModelInfoPOShort,
  ModelSharedForm,
  ModelFrance,
  ModelUSA
}
